package com.evoapps.evoshift.domain.usecase

import com.evoapps.evoshift.domain.model.RosterStatus
import com.evoapps.evoshift.domain.repository.RosterRepository

class FinalizeRosterSkeletonUseCase(
    private val rosterRepository: RosterRepository
) {
    suspend operator fun invoke(rosterId: String): Result<Unit> {
        return try {
            val roster = rosterRepository.getRoster(rosterId).getOrThrow()
            if (roster.status != RosterStatus.SKELETON) {
                return Result.failure(Exception("Roster is not in SKELETON phase"))
            }
            rosterRepository.updateRosterStatus(rosterId, RosterStatus.DRAFT)
        } catch (e: Exception) {
            Result.failure(e)
        }
    }
}